module.exports = __webpack_public_path__ + "img/Nyromantikk_Andre_kunstformer3.310eab82.jpg";